import { randomRgb } from "@/common/utils";
import VueLazyload from "vue3-lazyload";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueLazyload, {
    loading: "", // 预加载时的占位图
    error: "", // 加载失败时的占位图
    attempt: 1,
    throttleWait: 10000,
    listenEvents: ["scroll"],
    observer: true,
    observerOptions: {
      rootMargin: "0px",
      threshold: 0.1,
    },
  });
});
